import { Dispatch, SetStateAction, FC, memo } from 'react'
import { useForm } from 'react-hook-form'
import { Box, Button, Flex, Select, useDisclosure } from '@chakra-ui/react'

import { Place } from 'Geo/types'
import { DescriptionItem, FilterTemplate, FormItem } from 'components'

export type PlacesFilterTemplateProps = {
  places: Place[]
  title?: string
  description?: string
  filter: any
  setFilter: Dispatch<SetStateAction<any>>
}

const PlacesFilterTemplate: FC<PlacesFilterTemplateProps> = ({
  title = 'Filtrando pelo local',
  description = 'Selecione um local para filtrar por ele',
  places,
  filter,
  setFilter,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  const { register, handleSubmit } = useForm()

  function onSubmit(place: Place) {
    setFilter({ ...filter, place_name: place.place_name })
    onClose()
  }

  return (
    <FilterTemplate
      title={title}
      description={description}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      content={
        <Box as="form" id="place-form" onSubmit={handleSubmit(onSubmit)}>
          <FormItem label="Locais disponíveis" htmlFor="place_name">
            <Select id="place_name" {...register('place_name')}>
              <option value="">Todos</option>
              {places.map((place) => (
                <option key={place.id} value={place.name}>
                  {place.name}
                </option>
              ))}
            </Select>
          </FormItem>

          <Button type="submit" form="place-form" minWidth="100%">
            Filtrar
          </Button>
        </Box>
      }
      contentWhenClosed={
        <Box>
          {filter.place_name && (
            <Flex direction="column" px={4} pb={filter.place_name ? 4 : 0}>
              <DescriptionItem direction="row" label="Local selecionado" value={filter.place_name} />
            </Flex>
          )}
        </Box>
      }
    />
  )
}

export default memo(PlacesFilterTemplate)
